import { clamp, Notifier, Option, Terminator } from "@opendaw/lib-std";
export class FieldAdapter {
    #field;
    #valueMapping;
    #stringMapping;
    #name;
    #anchor;
    #terminator = new Terminator();
    #valueChangeNotifier;
    #trackBoxAdapter = Option.None;
    constructor(field, valueMapping, stringMapping, name, anchor) {
        this.#field = field;
        this.#valueMapping = valueMapping;
        this.#stringMapping = stringMapping;
        this.#name = name;
        this.#anchor = anchor ?? 0.0;
        this.#valueChangeNotifier = this.#terminator.own(new Notifier());
        this.#terminator.own(this.#field.subscribe(() => this.#valueChangeNotifier.notify(this)));
        /*
        For debugging: It's not live because floating errors expose false positives,
            and I am too lazy to implement this in the mappings itself.
        */
        if (field.getValue() !== valueMapping.clamp(field.getValue())) {
            console.warn(`${name} (${field.getValue()}) is out of bounds`, valueMapping);
        }
    }
    get field() { return this.#field; }
    get valueMapping() { return this.#valueMapping; }
    get stringMapping() { return this.#stringMapping; }
    get name() { return this.#name; }
    get anchor() { return this.#anchor; }
    get type() { return this.#field.type; }
    get address() { return this.#field.address; }
    get track() { return this.#trackBoxAdapter; }
    subscribe(observer) { return this.#valueChangeNotifier.subscribe(observer); }
    catchupAndSubscribe(observer) {
        observer(this);
        return this.subscribe(observer);
    }
    getValue() { return this.#field.getValue(); }
    setValue(value) { this.#field.setValue(this.#valueMapping.clamp(value)); }
    setUnitValue(value) { this.setValue(this.#valueMapping.y(value)); }
    getUnitValue() { return this.#valueMapping.x(this.getValue()); }
    getPrintValue() { return this.#stringMapping.x(this.getValue()); }
    setPrintValue(text) {
        const result = this.#stringMapping.y(text);
        if (result.type === "unitValue") {
            this.setUnitValue(clamp(result.value, 0.0, 1.0));
        }
        else if (result.type === "explicit") {
            this.setValue(this.valueMapping.clamp(result.value));
        }
        else {
            console.debug(`Unknown text input: '${result.value}'`);
        }
    }
    reset() { this.setValue(this.#valueMapping.clamp(this.#field.initValue)); }
    terminate() { this.#terminator.terminate(); }
}
